import { render, staticRenderFns } from "./expedientes.vue?vue&type=template&id=51374e23"
import script from "./expedientes.vue?vue&type=script&lang=js"
export * from "./expedientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports